import Label from '../Label'

type InputProps = {
  name: string
  label?: string
  placeholder?: string
  [x: string]: unknown
}

export const Input = ({ label, placeholder, name, ...props }: InputProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {label && <Label text={label} name={name} />}
      <input
        {...props}
        placeholder={placeholder}
        className="bg-white rounded-lg border border-[#e6ebf5] text-neutral-100 p-[12px] placeholder:text-neutral-30"
        name={name}
        type="text"
      />
    </div>
  )
}
